import React, { Component } from 'react';
import Icon from '../Icon';
import './styles.scss';

class AdminHeader extends Component {
	render() {
		return (
			<div className="AdminHeader">
				<Icon className="icon-bocconi" icon={'bocconi'} />
				<Icon className="icon-erisPoint" icon={'erisPoint'} />
				<Icon className="icon-logoAreaAdminHeader" icon={'logoAreaHeader'} />


			</div>
		);
	}
}

export default AdminHeader;
